import { render, staticRenderFns } from "./StandalonePaxMode.vue?vue&type=template&id=f44e0ce8"
import script from "./StandalonePaxMode.vue?vue&type=script&lang=js"
export * from "./StandalonePaxMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports